import { useSpaceResource } from "@circle-react/contexts";

export const orderLessons = sections =>
  sections?.flatMap(section =>
    section.lessons.map(l => ({
      ...l,
      section_id: section.id,
    })),
  ) || [];

export const useOrderedLessons = ({ spaceId }) => {
  const { data: spaceResource } = useSpaceResource({
    spaceId: spaceId,
  });

  return orderLessons(spaceResource?.course_sections);
};
